import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicRateCardPercentageInactive({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 45 29"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M36.69 0L23.64 28.63H20.6L33.65 0h3.04zm1.68 13.95a6.49 6.49 0 016.55 6.42 6.49 6.49 0 01-6.55 6.43 6.49 6.49 0 01-6.55-6.43 6.49 6.49 0 016.55-6.42zm0 2.94a3.52 3.52 0 00-3.55 3.48 3.52 3.52 0 003.55 3.49 3.52 3.52 0 003.55-3.49 3.52 3.52 0 00-3.55-3.48zM18.55 2.94a6.49 6.49 0 016.54 6.42 6.49 6.49 0 01-6.54 6.42A6.49 6.49 0 0112 9.36a6.49 6.49 0 016.55-6.42zm0 2.93a3.52 3.52 0 00-3.56 3.5c0 1.92 1.6 3.48 3.56 3.48a3.52 3.52 0 003.55-3.49c0-1.93-1.6-3.49-3.55-3.49z"
        fill="#F5F7F7"
        fillRule="evenodd"
        opacity={0.8}
      />
    </svg>
  );
}

SvgPicRateCardPercentageInactive.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicRateCardPercentageInactive.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicRateCardPercentageInactive svgRef={ref} {...props} />
));
export default ForwardRef;
